import { FlexGrid, FlexGridItem, HeadingLarge } from "@mezo-org/mezo-clay"

import { IS_MEZO_MAINNET } from "#/shared/constants"
import { SanityCmsDataType, useSanityCmsData } from "#/shared/hooks"
import { buildUrlForSanityCmsImage } from "#/shared/utils"
import { InnerContainer } from "#/ui/Layout"

import LearnSectionFaq from "./LearnSectionFaq"
import LearnSectionUsefulPosts from "./LearnSectionUsefulPosts"

type LearnSectionData = {
  faqLearn: { title: string; paragraph: string }[]
  postLearn: {
    description: string
    title: string
    url: string
    image: { asset: { _ref: string } }
  }[]
  title: string
}

export default function LearnSection() {
  const { data: learnData, error: learnError } =
    useSanityCmsData<LearnSectionData>(
      IS_MEZO_MAINNET
        ? SanityCmsDataType.Learn
        : SanityCmsDataType.LearnTestnet,
    )

  if (!learnData || learnError) return null

  const { faqLearn, postLearn, title: learnSectionTitle } = learnData

  return (
    <InnerContainer
      backgroundColor="F3F3F3"
      paddingBottom="128px"
      position="relative"
      overrides={{ Block: { style: () => ({ zIndex: 2 }) } }}
    >
      <HeadingLarge marginBottom="16px">{learnSectionTitle}</HeadingLarge>
      <FlexGrid
        flexGridColumnCount={[1, 1, 1, 2]}
        flexGridColumnGap="scale900"
        flexGridRowGap="scale600"
      >
        <FlexGridItem>
          <LearnSectionUsefulPosts
            posts={postLearn.map(({ description, image, title, url }) => ({
              content: description,
              href: url,
              image: buildUrlForSanityCmsImage(image),
              title,
            }))}
          />
        </FlexGridItem>
        <FlexGridItem>
          <LearnSectionFaq
            faq={faqLearn.map(({ paragraph, title }) => ({
              key: title,
              title,
              children: paragraph,
            }))}
          />
        </FlexGridItem>
      </FlexGrid>
    </InnerContainer>
  )
}
